import React, { useState, useEffect, useContext, useCallback } from "react";
import { ControlContext } from "./ControlContext";

import BasicPack from "../Graphics/BasicPack/Graphics.js";
import useLocalStorage from "../Hooks/useLocalStorage.js";

// const viz = new Viz("FOOTBALL_2020");
const viz = {};
const GraphicsContext = React.createContext([{}, () => {}]);

const GraphicsProvider = (props) => {
  const {
    animate,
    preview,
    update,
    animateOff,
    clearPreview,
    triggerAnimation,
  } = useContext(ControlContext);
  const [graphics, setGraphics] = useState();
  const [graphicInPreview, setGraphicInPreview] = useState();
  const [style, setStyle] = useState("BASIC");
  const [showBackground, setShowBackground] = useState(false);
  const [timelineGraphicsStatus, setTimelineGraphicsStatus] = useLocalStorage(
    "timeline-graphic-status",
    []
  );
  useEffect(() => {
    switch (style) {
      case "BASIC":
        setGraphics(
          BasicPack({
            preview,
            animate,
            update,
            animateOff,
            triggerAnimation,
            clearPreview,
          })
        );
        break;
      default:
    }
  }, [style]);

  const previewGraphic = useCallback(
    (name, options) => {
      if (graphics) {
        let graphic = graphics.find((graphic) => graphic.name === name);
        if (graphic) {
          graphic.preview({ options });
          if (options.timeline_status_id) {
            let new_timeline_graphics_status = [...timelineGraphicsStatus];
            new_timeline_graphics_status = new_timeline_graphics_status.filter(
              (tl) =>
                tl.id !== options.timeline_status_id &&
                tl.id?.indexOf(options.game?._id) > -1
            );
            new_timeline_graphics_status.push({
              id: options.timeline_status_id,

              status: "preview",
            });
            setTimelineGraphicsStatus(new_timeline_graphics_status);
          }
          if (graphic && graphic.name !== "CLOCK") {
            graphic.timeline_status_id = options.timeline_status_id;
            setGraphicInPreview(graphic);
          }
        }
      }
    },
    [preview, graphics, timelineGraphicsStatus]
  );

  const animateGraphic = useCallback(
    (name, options) => {
      let graphic = graphics.find((graphic) => graphic.name === name);
      if (graphic) {
        if (graphicInPreview && graphicInPreview.timeline_status_id) {
          let new_timeline_graphics_status = [...timelineGraphicsStatus];
          new_timeline_graphics_status = new_timeline_graphics_status.filter(
            (tl) => tl.id !== graphicInPreview.timeline_status_id
          );
          new_timeline_graphics_status.push({
            id: graphicInPreview.timeline_status_id,
            status: "animated",
          });
          setTimelineGraphicsStatus(new_timeline_graphics_status);
        }
        graphic.animate({ options });
      }
      // if (
      //   style === "SKY" &&
      //   graphic.name === "HeroFormation" &&
      //   graphic.stage === 14
      // ) {
      //   setGraphicInPreview();
      // }
    },
    [animate, graphics, timelineGraphicsStatus, graphicInPreview]
  );

  const animateOffGraphic = useCallback(
    (name, options) => {
      let graphic = graphics.find((graphic) => graphic.name === name);
      if (graphic) {
        graphic.animateOff({ options });
        setGraphicInPreview();
      }
    },
    [animate, graphics]
  );

  const updateGraphic = useCallback(
    (name, options) => {
      if (graphics) {
        let graphic = graphics.find((graphic) => graphic.name === name);
        if (graphic) {
          graphic.update({ options });
        }
      }
    },
    [animate, graphics]
  );

  const clearPVW = useCallback(
    (name) => {
      clearPreview(name);
      setGraphicInPreview();
    },
    [graphicInPreview, clearPreview]
  );

  return (
    <GraphicsContext.Provider
      value={{
        previewGraphic,
        animateGraphic,
        graphicInPreview,
        animateOffGraphic,
        updateGraphic,
        clearPVW,
        showBackground,
        setShowBackground,
        timelineGraphicsStatus,
        setTimelineGraphicsStatus,
      }}
    >
      {props.children}
    </GraphicsContext.Provider>
  );
};

export { GraphicsContext, GraphicsProvider };
